import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/app/apps/web/src/app/(auth)/login/login-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_react-_cbb1d25331cde32d05160a94ecf959f7/node_modules/next/dist/client/app-dir/link.js");
